





























































































































































































































































































import Header from './components/Header.vue';
import CookieDlg from './components/CookieDlg.vue';
import {Component, Vue} from 'vue-property-decorator';
import {AboutPricing, AboutPrivacy, AboutTeam, AboutTos, Signin, Signup} from './Routes';
import {installGoogleAnalytics} from './utils/Analytics';
import {setErrorWidget} from './utils/Ui';
import ErrorWidget from './components/ErrorWidget.vue';

const $ = require('jquery');

@Component({
    components: {ErrorWidget, Header, CookieDlg},
  })
  export default class Landing extends Vue {
    public readonly routes = {
      SIGNUP: Signup,
      ABOUT_PRICING: AboutPricing,
      ABOUT_TOS: AboutTos,
      ABOUT_PRIVACY: AboutPrivacy,
      ABOUT_TEAM: AboutTeam,
      LOGIN: Signin,
    };
    public readonly sectionOffsets: MutableList<SectionOffset> = [];
    public readonly needsCookieConsent: boolean = window.needsCookieConsent || false;
    public $refs!: {
      cookieDlg: CookieDlg
      errorWidget: ErrorWidget,
    };

    public mounted() {
      $('.section').each((_, domSection) => {
        this.sectionOffsets.push(new SectionOffset($(domSection)));
      });
      $('main').on('scroll', this.stickifySections);

      $('.scroll-up a').on('click', function(e) {
        $('main').scrollTop(0);
        window.location.hash = '';
        e.preventDefault();
      });
      window.onhashchange = () => {
        this.processHashChange(window.location.hash, undefined);
      };
      if (this.needsCookieConsent) {
        this.$refs.cookieDlg.show();
      }
      setErrorWidget(this.$refs.errorWidget);
    }
    private cdnUrl(path: string): string {
      return path;
    }

    private stickifySections = () => {
      this.sectionOffsets.map((sectionOffset, index) => {
        sectionOffset.setZIndex(index - this.sectionOffsets.length);
      });
    }

    // This function returns the top offset of the given section if
// all sections were laid out one after another, just like after page loading.
    private getStartScroll(hash: string): number {
      let scroll = 0;
      let stop = false;
      this.sectionOffsets.forEach((section) => {
        // Iterate all sections until we find the given one.
        // If section's offset is close to 9 (hello Edge! you have it 0.9)
        // then it is currently "sticky" and we add its height to the sum
        const sectionHash = `#${section.id}`;
        if (sectionHash === hash) {
          stop = true;
        } else {
          if (!stop && section.getOffsetTop() <= 1) {
            scroll += section.getHeight();
          }
        }
      });
      return scroll;
    }

    // This function is called when page hash changes.
// Hash change may trigger automatic scroll (this is the cae when we click
// one of the scroll-down buttons). However, it may not trigger scroll (e.g.
// when we click scroll-up or use browser history buttons), and in
// this case we have to scroll on our own.
// If scroll is triggered automatically then this function may be called either
// when page has already been scrolled to the target element or somewhere in the middle of
// scrolling.
// In the first case we don't want to do anything.
// In the second case we schedule another call of this function and do so until scrolling
// stops or we run out of attempts.
    private processHashChange(hash: string, prevOffset?: number, counter = 5) {
      const main = $('main');
      if (hash === '' || hash === '#' || hash === '#top') {
        main.scrollTop(0);
        return;
      }
      const hashOffset = $(hash).position();
      if (hashOffset.top <= 1) {
        // This element is already scrolled to the top of the page,
        // but chances are that it is sticky and hiding behind subsequent sections.
        const scroll = this.getStartScroll(hash);
        if (scroll !== main.scrollTop()) {
          main.scrollTop(scroll);
        }
      } else {
        // Section is somewhere far away. However, chances are that it is scrolling right now.
        // Let's compare its current offset with the previous one (if any) and if they
        // are the same then no, we're not scrolling. Otherwise try again in 50ms.
        if (prevOffset !== undefined && hashOffset.top === prevOffset) {
          main.scrollTop(this.getStartScroll(hash));
        } else {
          if (counter > 0) {
            window.setTimeout(this.processHashChange, 50, hash, hashOffset.top, counter - 1);
          }
        }
      }
    }
  }

class SectionOffset {
    public readonly contents: JQuery;
    public readonly id: string;

    constructor(readonly section: JQuery) {
        this.contents = this.section.find('.contents');
        this.id = section.attr('id');
    }

    public setZIndex(value: number) {
        this.contents.css('z-index', value);
    }

    public getOffsetTop(): number {
        return this.contents.position().top;
    }

    public getHeight(): number {
        return this.contents.height();
    }
}

installGoogleAnalytics();

// if (window["needsCookieConsent"]) {
//     window.setTimeout(function () {
//         const dlg = new CookieDlg();
//         dlg.show();
//     }, 100);
// }
